import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const LabelBox = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LectureList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  max-height: 500px;
  overflow-y: auto;
`;
export const LectureCard = styled.li`
  width: 100%;
  padding: 1.6rem;
  background-color: #1f1e25;
  border: 1px solid #2e2b36;
  border-radius: 8px;
  &:hover {
    border: 1px solid #7750e9;
  }
`;

export const Text = styled.p`
  color: #eae8ed;
  &.point {
    font-size: 13px;
    color: #9170f2;
    margin-bottom: 8px;
  }
  &.title {
    font-size: 16px;
  }
  &.description {
    font-size: 12px;
    color: #8e899f;
    margin-bottom: 12px;
  }
`;

export const Price = styled.p`
  color: #eae8ed;
  font-size: 18px;
  text-align: right;
  > span {
    font-size: 14px;
  }
`;
